<template>
  <div>
    <NuxtLayout>
      <NuxtPage class="page-app"/>
    </NuxtLayout>
    <UModals />
  </div>
</template>